import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/thumbs-up-on.svg'
import _imports_1 from '@/assets/images/thumbs-up-off.svg'


const _withScopeId = n => (_pushScopeId("data-v-3591b77b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["infinite-scroll-disabled"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "info color-info" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = {
  key: 0,
  class: "iine"
}
const _hoisted_9 = { class: "color-success" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "14",
  height: "14",
  class: "image-position"
}, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "iine"
}
const _hoisted_12 = { class: "color-success" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "14",
  height: "14",
  class: "image-position"
}, null, -1))

import { computed, ref, onMounted } from "vue";
import { Question } from "@/types/question"
import { ChatDotRound } from '@element-plus/icons';

interface Props {
  questions: Question[];
  question_id: number | null;
  listLoading: boolean;
  noMore: boolean;
  questionCategoryId: number;
}
interface Emits {
  (e: "load"): void;
  (e: "showDetail", question_id: number): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    questions: { type: Array, required: true },
    question_id: { type: [Number, null], required: true },
    listLoading: { type: Boolean, required: true },
    noMore: { type: Boolean, required: true },
    questionCategoryId: { type: Number, required: true }
  },
  emits: ["load", "showDetail"],
  setup(__props: any, { emit }: { emit: ({
  (e: "load"): void;
  (e: "showDetail", question_id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  questions: Question[];
  question_id: number | null;
  listLoading: boolean;
  noMore: boolean;
  questionCategoryId: number;
}


const load = () => {
  emit("load");
};
const showDetail = (question_id: number) => {
  emit("showDetail", question_id);
};
// infinite-scrollのエラー対応。描画前にupdatedでエラーが出る
// runtime-core.esm-bundler.js:6737 TypeError: Cannot destructure property 'containerEl' of 'e[yC]' as it is undefined.  at updated (index.mjs:120:13)
const delay_view = ref(false)
onMounted(() => {
  delay_view.value = true
});
const loadDisable = computed(() => props.listLoading || props.noMore);
// クリックしたタイミングでactiveを変えつつ、Questionのロードが終わったら、今表示しているQuestionをactiveにするため
// こうしないと表示してるQuestionとQuestionListのactiveになってる物が違う物を指す状態が発生するため
const select_question_id = computed(() => props.question_id ? props.question_id : activeRowKey.value)
const activeRowKey = ref(0);

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_fa = _resolveComponent("fa")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (delay_view.value)
      ? _withDirectives((_openBlock(), _createElementBlock("ul", {
          gutter: 12,
          class: "infinite-list",
          "infinite-scroll-disabled": _unref(loadDisable),
          key: __props.questionCategoryId
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.questions, (question) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["question", { active: _unref(select_question_id) === question.id }]),
              span: 24,
              key: question.id,
              onClick: () => activeRowKey.value = question.id
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (showDetail(question.id)),
                shadow: "hover"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_badge, {
                    "is-dot": "",
                    class: "item",
                    hidden: question.notice_comment != true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChatDotRound))
                    ]),
                    _: 2
                  }, 1032, ["hidden"]),
                  _withDirectives(_createVNode(_component_fa, {
                    icon: ['fas', 'star'],
                    class: "color-yellow favoraite-icon"
                  }, null, 512), [
                    [_vShow, question.favorite]
                  ]),
                  _withDirectives(_createVNode(_component_fa, {
                    icon: ['far', 'star'],
                    class: "color-info favoraite-icon"
                  }, null, 512), [
                    [_vShow, !question.favorite]
                  ]),
                  _createElementVNode("span", {
                    innerHTML: question.body_html
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(question.user_name) + " ", 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(question.post_at), 1)
                ]),
                (question.iine)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(question.iine_count), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(question.iine_count), 1)
                      ])
                    ]))
              ], 8, _hoisted_3)
            ], 10, _hoisted_2))
          }), 128))
        ], 8, _hoisted_1)), [
          [_directive_infinite_scroll, load]
        ])
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_loading, __props.listLoading]
  ])
}
}

})